import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const fetchWorker = (id) => api.get(`/workers/${id}`).then((r) => r.data);
export const fetchVerification = (id) => api.get(`/verify/${id}`).then((r) => r.data);
export const fetchEmployer = (id) => api.get(`/employers/${id}`).then((r) => r.data);
